import React from 'react';
import ProfileSvg from '@/assets/icons/profile.svg?react';

interface ProfileIconProps {
  className?: string;
  size?: number;
}

const ProfileIcon: React.FC<ProfileIconProps> = ({ className = "w-7 h-7", size }) => {
  return (
    <ProfileSvg
      className={className}
      width={size}
      height={size}
    />
  );
};

export default ProfileIcon;
